export default __webpack_public_path__ + "7d2477c8ddda02f6bf3c53aeb6661f40.png";